import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Stack,
  TextField,
  alpha
} from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

import { Section } from './Section'

const ClientCoreSection = ({
  detail,
  coreDraft,
  coreDirty,
  savingCore,
  onPatch,
  onSave,
  onDelete
}) => (
  <Section
    title={detail.label || 'Client'}
    hint={`id · ${detail.id}`}
    actions={(
      <Button
        size='small'
        color='error'
        startIcon={<DeleteOutlineIcon />}
        onClick={onDelete}
      >
        Delete
      </Button>
    )}
  >
    <Stack spacing={1.25}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25}>
        <TextField
          size='small'
          label='Label'
          fullWidth
          value={coreDraft.label}
          onChange={(e) => onPatch({ label: e.target.value })}
        />
        <TextField
          size='small'
          label='Color'
          value={coreDraft.color}
          onChange={(e) => onPatch({ color: e.target.value })}
          sx={{ width: { sm: 140 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    borderRadius: '50%',
                    bgcolor: coreDraft.color || '#6b7280',
                    border: `1px solid ${alpha('#fff', 0.25)}`
                  }}
                />
              </InputAdornment>
            )
          }}
        />
      </Stack>
      <Stack direction='row' flexWrap='wrap' gap={0.5}>
        <FormControlLabel
          control={(
            <Checkbox
              size='small'
              checked={coreDraft.isActiveSupport}
              onChange={(e) => onPatch({ isActiveSupport: e.target.checked })}
            />
          )}
          label='Active support'
        />
        <FormControlLabel
          control={(
            <Checkbox
              size='small'
              checked={coreDraft.zendeskTracking}
              onChange={(e) => onPatch({ zendeskTracking: e.target.checked })}
            />
          )}
          label='Zendesk'
        />
        <FormControlLabel
          control={(
            <Checkbox
              size='small'
              checked={coreDraft.vulnTracking}
              onChange={(e) => onPatch({ vulnTracking: e.target.checked })}
            />
          )}
          label='Vuln board'
        />
        <FormControlLabel
          control={(
            <Checkbox
              size='small'
              checked={coreDraft.upgradeTracking}
              onChange={(e) => onPatch({ upgradeTracking: e.target.checked })}
            />
          )}
          label='Upgrades board'
        />
      </Stack>
      <Box>
        <Button
          size='small'
          variant='contained'
          disabled={!coreDirty || savingCore || !coreDraft.label.trim()}
          onClick={onSave}
        >
          {savingCore ? 'Saving…' : 'Save settings'}
        </Button>
      </Box>
    </Stack>
  </Section>
)

export { ClientCoreSection }
